<template>
  <section>
    <div>
      <div>
        <h2>{{titlePage}}</h2>
        <h4>{{pageDescription}}</h4>

        <form @submit.prevent="updateTitle">
          <div class="form-field">
            <label for="newTitle">Title</label>
            <input id="newTitle" v-model="newTitle" required autofocus />
          </div>
          <div class="form-field">
            <label for="newTitle">Description</label>
            <textarea
              id="newDescription"
              v-model="newDescription"
              @input="mixin_autoResize_resize"
              @focus="mixin_autoResize_resize"
            />
          </div>
          <div>
            <primary-button :title="'Confirm'" :act="updateTitle"></primary-button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../../api";
import bus from "../../bus";

import mixinAutoResize from "../../mixins/autoResize.js";

import PrimaryButton from "@/components/shared/PrimaryButton";

export default {
  data() {
    return {
      newTitle: this.list.title,
      newDescription: this.list.description,
      titlePage: "Edit list",
      pageDescription: "Edit the title and description of the list"
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  components: {
    PrimaryButton,
  },
  methods: {
    updateTitle: function () {
      api
        .updateList(
          this.list.id,
          this.list.status,
          this.newTitle,
          this.newDescription
        )
        .then(() => {
          bus.$emit("close-modal");
        })
        .catch(function (error) {
          this.$rollbar.error(error);
          alert("There was an error updating the session. Please try again later.");
        });
    },
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinAutoResize],
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

@import "@/styles/form.scss";

.page-title {
  margin-bottom: 40px;
}

form {
  margin-top: 40px;
}

.form-field {
  margin-bottom: 24px;
}

.form-field > * {
  display: block;
  border-color: theme.$text-color;
}

.primary-button {
  margin-top: top 30px;
  text-align: center;
}

textarea {
  border: 1px solid theme.$text-color;
  border-radius: 4px;
  padding: 6px 8px;
  width: 100%;
  outline: none;
  max-height: 140px;
  resize: vertical;
  font-size: 14px;
  font-weight: 200;
  min-height: 6em;
}
</style> 